import React from 'react';
import Loadable from '../../components/loadable';

const HtmlEditor = Loadable({
  loader: () => import('../../components/html_editor'),
  loading: () => <div className="loading-placeholder" style={{ height: 600, marginBottom: 15 }} />,
});

angular.module('shared').value('HtmlEditor', HtmlEditor);
